export const RESET_STORE = "RESET_STORE";

export const resetStore = (retainUserDetails = false) => ({
  type: RESET_STORE,
  retainUserDetails, 
});
